import { ValueFormatterParams } from '@ag-grid-community/core'
import _ from 'lodash-es'

/**
 * Format to be title cased. Used to interface with as the ag-grid formatter.
 * example: "TEST_INPUT_VALUE" -> "Test Input Value"
 */
export function titleCaseFormatter(params: ValueFormatterParams) {
  const { value } = params
  if (value == null) return ''
  const cleanedTitle = value.replace(/_/g, ' ')
  return _.startCase(_.toLower(cleanedTitle))
}
